import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";
import { ITileHeaderProps } from ".";

const classNames = {
  root: `TileHeader`
};

export function useTileHeaderStyles(props: ITileHeaderProps) {
  const { styleSet, asSubHeader = false } = props;
  const { semanticColors, fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          asSubHeader ? fonts.medium : fonts.large,
          {
            padding: `8px 16px`,
            display: `block`,
            wordWrap: `break-word`,
            width: `calc(100% - 32px)`,
            height: asSubHeader ? `18px` : `22px`,
            lineHeight: asSubHeader ? `18px` : `22px`,
            color: asSubHeader ? semanticColors.bodySubtext : semanticColors.bodyText,
            ...textOverflow
          },
          asSubHeader ? { paddingTop: 0 } : null
        ]
      },
      styleSet
    ),
    [semanticColors, fonts, styleSet, asSubHeader]
  );
}
